/**
 * Les règles de mot de passe, telles que le serveur les applique.
 *
 * `AUTH_PASSWORD_VALIDATORS` exige huit caractères, au moins une lettre et au
 * moins un chiffre. L'écran annonçait seulement la longueur : on se voyait
 * refuser un mot de passe pour une raison qu'on n'avait pas lue.
 */
export const LONGUEUR_MINIMALE = 8;

export const EXIGENCE = 'Au moins 8 caractères, dont une lettre et un chiffre.';

export function defautDuMotDePasse(valeur) {
  if (!valeur) return null;
  if (valeur.length < LONGUEUR_MINIMALE) return EXIGENCE;
  if (!/[a-zA-Z]/.test(valeur) || !/[0-9]/.test(valeur)) return EXIGENCE;
  return null;
}
